<template>
  <div class="view-leads">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ $t('labels.lead_detail') }}</h2>
      </div>
      <div class="history w-1/2 justify-right">
        <vs-button
          color="dark"
          type="filled"
          icon-pack="feather"
          icon="icon-activity"
          @click="$router.push({ name: 'History', params: {id: id,model: model }})"
          class="float-right"
        >{{ $t('labels.history')}}</vs-button>
      </div>
    </div>

    <div class="view-lead">
      <vx-card class="contact-details mb-8" :title="$t('labels.contact_detail')">
        <div class="vx-row mb-4">
          <div class="vx-col w-full mb-4">
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t('labels.organisation_name') }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ organisation_name }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t('labels.contact_name') }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ contact_name }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t('labels.email') }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ email }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t('labels.phone') }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ phone }}</span>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <vx-card class="vessel-details mb-8" :title="$t('labels.vessel_detail')">
      <div class="vx-row mb-4">
        <div class="vx-col w-full mb-4">
          <div class="vx-row mb-4">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.name') }}</label>
            </div>
            <div class="vx-col sm: w-1/2 mb-4">
              <span>{{ name }}</span>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.imo_number') }}</label>
            </div>
            <div class="vx-col sm: w-1/2 mb-4">
              <span>{{ imo_number }}</span>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.date_of_attendence') }}</label>
            </div>
            <div class="vx-col sm: w-1/2 mb-4">
              <span>{{ date | moment("YYYY-MM-DD") }}</span>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.port_detail') }}</label>
            </div>
            <div class="vx-col sm: w-1/2 mb-4">
              <span>{{ port_details }}</span>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.agent_detail') }}</label>
            </div>
            <div class="vx-col sm: w-1/2 mb-4">
              <span>{{ agent_details }}</span>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.service_requirement') }}</label>
            </div>
            <div class="vx-col sm: w-1/2 mb-4">
              <span>{{ service_requirements }}</span>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
    <vx-card class="others mt-4" :title="$t('labels.others')">
      <div class="vx-row mb-4">
        <div class="vx-col w-full mb-4">
          <div class="vx-row mb-4">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.remarks') }}</label>
            </div>
            <div class="vx-col sm: w-1/2 mb-4">
              <span>{{ remarks }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.status') }}</label>
            </div>
            <div class="vx-col sm: w-1/2 mb-4">
              <span>{{ status }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="vx-row justify-center">
        <vs-button
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-chevron-left"
          class="mr-4 mt-8 back-btn"
          align="center"
          :to="{name:'Leads'}"
        >{{ $t('labels.back') }}</vs-button>
      </div>-->
    </vx-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      organisation_name: "",
      contact_name: "",
      email: "",
      phone: "",
      name: "",
      imo_number: "",
      date: "",
      port_details: "",
      agent_details: "",
      service_requirements: "",
      remarks: "",
      status: "",
      model: 'lead',
      id: this.$route.params.id,
    };
  },
  computed: {},
  mounted() {
    this.getLeads();
  },
  methods: {
    async getLeads() {
      let response = await this.getHTTPGetResponse(
        "/leads/get/" + this.$route.params.id
      );

      if (response) {
        let lead = response.data.lead;
        this.organisation_name = lead.organisation_name;
        this.contact_name = lead.name;
        this.email = lead.email;
        this.phone = lead.phone;
        this.name = lead.vessel_name;
        this.imo_number = lead.vessel_imo_number;
        this.date = lead.vessel_date_of_attendence;
        this.port_details = lead.vessel_port_details;
        this.agent_details = lead.vessel_agent_details;
        this.service_requirements = lead.vessel_service_requirements;
        this.remarks = lead.remarks;
        this.status = lead.status_name;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>
<style scoped>
.view-leads label {
  font-weight: 600;
  margin-right: 10px;
}
h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}
</style>

